import React, { FC } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

import TopPerformingLabels from './TopPerformingLabels';
import TopPerformingMessages from './TopPerformingMessages';
import { TopPerformingTabs } from './constant';

interface TopPerformingProps {
    tab: TopPerformingTabs;
}

const TopPerformingTab: FC<React.PropsWithChildren<TopPerformingProps>> = ({
    tab,
}) => {
    return (
        <Container className="hide-scroll-bar">
            {tab == TopPerformingTabs.TopMessages && <TopPerformingMessages />}
            {tab == TopPerformingTabs.TopLabels && <TopPerformingLabels />}
        </Container>
    );
};

const Container = styled.span(() => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(2),
}));

export default TopPerformingTab;
